(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "normalizr", "@braindate/util/lib/assert", "./membershipAssertions", "../schema"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("normalizr"), require("@braindate/util/lib/assert"), require("./membershipAssertions"), require("../schema"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.normalizr, global.assert, global.membershipAssertions, global.schema);
    global.membershipNormalization = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _normalizr, _assert, _membershipAssertions, _schema) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.hydrateMembership = hydrateMembership;
  _exports.hydrateMemberships = hydrateMemberships;
  _exports.normalizeMembership = normalizeMembership;
  _exports.normalizeMemberships = normalizeMemberships;

  /**
   * Normalize a membership
   * @param   {Membership} membership - Membership to normalize
   * @returns {number} data.result - Id of the membership
   * @returns {NormalizedData<number>} data.entities - Normalized data entities
   *
   * @throws Will throw an exception if parameter is not an object
   */
  function normalizeMembership(membership) {
    (0, _membershipAssertions.assertMembership)(membership);
    return (0, _normalizr.normalize)(membership, _schema.membershipSchema);
  }

  /**
   * Normalize memberships
   * @param   {Array<Membership>} memberships - Memberships to normalize
   * @returns {Array<number>} data.result - Ids of the memberships
   * @returns {NormalizedData<Array<number>>} data.entities - Normalized data
   * entities
   *
   * @throws Will throw an exception if parameter is not an array
   */
  function normalizeMemberships(memberships) {
    (0, _assert.assertArray)(memberships, "memberships");
    return (0, _normalizr.normalize)(memberships, _schema.membershipsSchema);
  }

  /**
   * Denormalize a membership
   * @param   {number} id - Id of the membership
   * @param   {Entities} entities - Normalized data entities
   * @returns {Membership} Denormalized membership
   *
   * @throws Will throw an exception if parameters are invalid
   */
  function hydrateMembership(id, entities) {
    (0, _assert.assertNumber)(id, "id");
    (0, _assert.assertObject)(entities, "entities");
    return (0, _normalizr.denormalize)(id, _schema.membershipSchema, entities);
  }

  /**
   * Denormalize memberships
   * @param   {Array<number>} ids - Ids of the memberships
   * @param   {Entities} entities - Normalized data entities
   * @returns {Array<Membership>} Denormalized memberships
   *
   * @throws Will throw an exception if parameters are invalid
   */
  function hydrateMemberships(ids, entities) {
    (0, _assert.assertArray)(ids, "ids");
    (0, _assert.assertObject)(entities, "entities");
    return (0, _normalizr.denormalize)(ids, _schema.membershipsSchema, entities);
  }
});